import { useUser } from './UserContext';

const SYMBOLS = {
  GBP: '£', USD: '$', EUR: '€', PKR: 'Rs', INR: '₹',
  AUD: 'A$', CAD: 'C$', JPY: '¥', CHF: 'CHF ',
};

export function useCurrency() {
  const user = useUser();
  const code = user?.default_currency || 'GBP';
  const symbol = SYMBOLS[code] || code + ' ';
  return { code, symbol };
}
